import moment from "moment";
import Vue from "vue";
import { sortByLanguagePriority } from "@/utils/languagePriority";

export function formatTranslations(value: {LangCode?: string}[], pattern: string, joinSeparator: string) {  
  if (!value || value.length == 0) {
    return '';
  }
  const strings = sortByLanguagePriority(
    value.filter((x) => (x.LangCode || '').toLowerCase() !== 'lv')
  ).map(x=> {
    let text = pattern;
    Object.keys(x).forEach(key => {
      text = text.replace(key, (x as any)[key]);
    })
    return text;
  });
  return strings.join(joinSeparator || '');
}
 
Vue.filter('translations', formatTranslations);
